import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-4 offset-lg-8" }
const _hoisted_6 = { class: "input-group input-group-lg" }
const _hoisted_7 = { style: {"margin-top":"50px"} }
const _hoisted_8 = {
  class: "pull-left",
  style: {"margin":"0","padding":"0"}
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  style: {"color":"black !important"}
}
const _hoisted_11 = {
  key: 1,
  style: {"color":"black !important","font-style":"italic"}
}
const _hoisted_12 = { class: "pull-right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { style: {"margin-top":"20px","overflow-y":"visible"} }
const _hoisted_17 = {
  class: "table table-bordered table-hover table-browser",
  style: {"margin-bottom":"0 !important"}
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "fa-stack" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "fa-stack" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = {
  key: 0,
  type: "button",
  class: "btn btn-outline-secondary",
  disabled: "",
  "aria-disabled": "true"
}
const _hoisted_26 = {
  key: 1,
  class: "dropdown"
}
const _hoisted_27 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttributeEditorDialog = _resolveComponent("AttributeEditorDialog")!
  const _component_AttributeDeleterDialog = _resolveComponent("AttributeDeleterDialog")!
  const _component_AttributeDependenciesDialog = _resolveComponent("AttributeDependenciesDialog")!
  const _component_AttributesSectionEditor = _resolveComponent("AttributesSectionEditor")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AttributeEditorDialog, {
      viewModel: _ctx.attributeEditorDialog,
      onAttributeCreated: _ctx.attributeCreated,
      onAttributeUpdated: _ctx.attributeUpdated
    }, null, 8 /* PROPS */, ["viewModel", "onAttributeCreated", "onAttributeUpdated"]),
    _createVNode(_component_AttributeDeleterDialog, {
      viewModel: _ctx.attrDeleterDialog,
      onDeleteAttribute: _ctx.handleDeleteAttributeCommand,
      onShowDependencies: _ctx.showAttributeDependenciesViewer
    }, null, 8 /* PROPS */, ["viewModel", "onDeleteAttribute", "onShowDependencies"]),
    _createVNode(_component_AttributeDependenciesDialog, { viewModel: _ctx.attrDependenciesDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AttributesSectionEditor, {
      viewModel: _ctx.attributesSectionEditor,
      onUpdateSectionName: _ctx.handleRenameAttributesSectionCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateSectionName"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_ctx.rm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-6 d-flex align-items-center" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Attributes")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                role: "button",
                class: "btn btn-outline-secondary mr-1",
                style: {"padding":"0.7em 2em"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleExpandAll && _ctx.toggleExpandAll(...args)))
              }, "Collapse / Expand all"),
              _createElementVNode("button", {
                role: "button",
                class: "btn btn-success mr-1",
                style: {"padding":"0.7em 2em"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAttributeCreator()))
              }, "Create attribute"),
              _cache[3] || (_cache[3] = _createElementVNode("a", {
                class: "btn btn-outline-secondary btn-lg",
                href: "https://www.transparentchoice.com/user-guide/attributes",
                title: "User guide: Configure attributes",
                target: "_blank"
              }, [
                _createElementVNode("i", {
                  class: "fa fa-info",
                  "aria-hidden": "true"
                })
              ], -1 /* CACHED */))
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  placeholder: "Search for an attribute",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchPhrase) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.searchPhrase]
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "input-group-append" }, [
                  _createElementVNode("span", { class: "input-group-text" }, [
                    _createElementVNode("i", {
                      class: "fa-solid fa-magnifying-glass",
                      "aria-hidden": "true"
                    })
                  ])
                ], -1 /* CACHED */))
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionsView, (s) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_8, [
                  _createElementVNode("a", {
                    class: "text-dark",
                    onClick: ($event: any) => (s.Expanded = !s.Expanded)
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa mr-1", {'fa-angle-right': !s.Expanded, 'fa-angle-down': s.Expanded}])
                    }, null, 2 /* CLASS */),
                    (s.Name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(s.Name), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (!s.Name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Unnamed"))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", {
                    class: "text-dark",
                    onClick: ($event: any) => (_ctx.showAttributesSectionEditor(s))
                  }, "Edit section name", 8 /* PROPS */, _hoisted_13),
                  _cache[6] || (_cache[6] = _createTextVNode(" | ", -1 /* CACHED */)),
                  _createElementVNode("a", {
                    class: "text-dark",
                    onClick: ($event: any) => (_ctx.showAttributeCreator(s.Name))
                  }, "Create attribute", 8 /* PROPS */, _hoisted_14)
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clearfix" }, null, -1 /* CACHED */))
              ]),
              (s.Expanded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("table", _hoisted_17, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", {
                                class: _normalizeClass(["sortable", { 'selected': s.OrderBy === 'name' }]),
                                onClick: ($event: any) => (s.orderByName())
                              }, [
                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-uppercase font-weight-normal" }, "Name", -1 /* CACHED */)),
                                _createElementVNode("span", _hoisted_19, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa fa-sort-asc fa-stack-1x", { 'selected': s.OrderBy === 'name' && s.OrderByDescending === false }])
                                  }, null, 2 /* CLASS */),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa fa-sort-desc fa-stack-1x", { 'selected': s.OrderBy === 'name' && s.OrderByDescending === true }])
                                  }, null, 2 /* CLASS */)
                                ])
                              ], 10 /* CLASS, PROPS */, _hoisted_18),
                              _createElementVNode("th", {
                                class: _normalizeClass(["sortable text-center", { 'selected': s.OrderBy === 'modified' }]),
                                style: {"width":"180px"},
                                onClick: ($event: any) => (s.orderByModified())
                              }, [
                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-uppercase font-weight-normal" }, "Updated on", -1 /* CACHED */)),
                                _createElementVNode("span", _hoisted_21, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa fa-sort-asc fa-stack-1x", { 'selected': s.OrderBy === 'modified' && s.OrderByDescending === false }])
                                  }, null, 2 /* CLASS */),
                                  _createElementVNode("i", {
                                    class: _normalizeClass(["fa fa-sort-desc fa-stack-1x", { 'selected': s.OrderBy === 'modified' && s.OrderByDescending === true }])
                                  }, null, 2 /* CLASS */)
                                ])
                              ], 10 /* CLASS, PROPS */, _hoisted_20),
                              _cache[10] || (_cache[10] = _createElementVNode("th", { style: {"width":"120px"} }, null, -1 /* CACHED */))
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.AttributesView, (attr) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: attr.Id,
                                class: _normalizeClass({'bg-danger': attr.IsSystem, 'table-warning': attr.IsCorporate})
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("h5", null, [
                                    (!attr.IsCorporate)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "text-dark",
                                          onClick: ($event: any) => (_ctx.showAttributeEditor(attr))
                                        }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_22))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(attr.Name), 1 /* TEXT */)),
                                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                    _createElementVNode("small", null, _toDisplayString(attr.InputTypeDisplayName), 1 /* TEXT */)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_24, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.getModifiedDateStr(attr)), 1 /* TEXT */),
                                  _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                  _createElementVNode("small", null, _toDisplayString(_ctx.getModifiedTimeStr(attr)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("td", null, [
                                  (attr.IsCorporate)
                                    ? (_openBlock(), _createElementBlock("button", _hoisted_25, " Enterprise "))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _cache[15] || (_cache[15] = _createElementVNode("button", {
                                          type: "button",
                                          class: "btn btn-outline-secondary dropdown-toggle",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }, " Actions ", -1 /* CACHED */)),
                                        _createElementVNode("div", _hoisted_27, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (_ctx.showAttributeEditor(attr))
                                          }, "Edit attribute", 8 /* PROPS */, _hoisted_28),
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (_ctx.showAttributeCloner(attr))
                                          }, "Clone attribute", 8 /* PROPS */, _hoisted_29),
                                          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (_ctx.showAttributeDependenciesViewer(attr.Id))
                                          }, "View dependencies", 8 /* PROPS */, _hoisted_30),
                                          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            onClick: ($event: any) => (_ctx.showAttributeDeleter(attr.Id))
                                          }, "Delete attribute", 8 /* PROPS */, _hoisted_31)
                                        ])
                                      ]))
                                ])
                              ], 2 /* CLASS */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}